import { Button, Text } from '@ksyos/design-system';
import { translateKey } from '../../../../../translate';
import { AnchorLink } from '../../../../elements/common';
import { List, ListItem } from '../../../../elements/List/List';
import { Modal } from '../../../../elements/modals/Modal';

interface IGgzbTherV1IndexListModalProps {
    setShowModal: (showModal: boolean) => void;
    showModal: boolean;
}

/* Static assets list constructed with unit test */
const filenames = [
    'ACT',
    'ACT_your_way',
    'ADHD',
    'Acceptance',
    'Activatie',
    'Alcohol_onder_controle',
    'Angst_bij_je_naaste',
    'Angst_bij_kinderen',
    'Angst_voor_de_tandarts',
    'Antidepressiva',
    'Autisme_bij_partners',
    'Balans',
    'Bewegen',
    'Bewegen_bij_lichamelijke_klachten',
    'Burn-out_bij_je_naaste',
    'Chronische_pijn',
    'Cognitief_Gedragsschema',
    'Communiceren',
    'Dagstructuur',
    'Dealing_with_corona_stress',
    'Denken_voelen_doen',
    'Depressie_CGT',
    'Diabetes-type-2',
    'Doelen-behalen',
    'Druk_en_afgeleid',
    'Dwang',
    'Echtscheiding-ouders',
    'Eenzaamheid',
    'Eenzaamheidsvirus',
    'Eerste-stap-naar-herstel',
    'Eetstoornis_-_op_de_wachtlijst',
    'Eetstoornissen_-_Gezinsondersteuning',
    'Emotie-eten_jan',
    'Faalangst_-_Jongeren',
    'Faalangst_-_Ouders',
    'Feeling_Gloomy',
    'G-schema_Compleet',
    'G-schema_met_meerdimensionaal',
    'G-schema_met_taartdiagram',
    'G-schema_met_uitdaagvragen',
    'G-schema_met_weegschaal',
    'Gedragsexperiment',
    'Geen-zin-in-seks',
    'Gegeneraliseerde_angst',
    'Geldzorgen_bij_je_naaste',
    'Geluk',
    'Gescheiden_ouders_-_jongeren',
    'Gokverslaving_bij_je_naaste',
    'Grip_op_je_emoties',
    'Grip_op_je_huishouden',
    'Het_hele_gezin_thuis',
    'Intakeformulier',
    'Interoceptieve-exposure',
    'KOPP_-_Jongeren',
    'Leefstijl',
    'Lekker_Slapen',
    'Loneliness',
    'Mantelzorg',
    'Mentale_revalidatie_na_corona',
    'Mentale_revalidatie_na_corona_-_sociale_omgeving',
    'Middelengebruik_bij_je_naaste',
    'Mindfulness_Jongeren',
    'Omgaan_met_Corona_-_jongeren',
    'Omgaan_met_emoties',
    'Ontspanning',
    'Opkomen_voor_jezelf',
    'Oplossinggsgericht_Opvoeden',
    'Ouders-Denken_voelen_doen',
    'Ouders-Zelfbeeld_kinderen',
    'Ouders_&_AD(H)D',
    'Overactive_and_inattentive',
    'Overgang',
    'Overspanning-burn-out',
    'PTSS_bij_je_naaste',
    'Paniek',
    'Piekeren',
    'Pijn_bij_vrijen',
    'Planning_en_structuur',
    'Relatieboost',
    'Rouw',
    'Rouw_bij_je_naaste',
    'SOLK',
    'Seks_en_of_Pornoverslaving',
    'Seksualiteit_-_Basisprogramma',
    'Slaap_shifts',
    'Slaaprestrictie',
    'Slechte_gewoontes',
    'Sleeping-well',
    'Somberheid',
    'Specifieke_Fobie',
    'Standing_up_for_yourself',
    'Stoppen_met_roken',
    'StressLes',
    'Te_veel_social_media',
    'Terugval_preventie',
    'Thuiswerken',
    'Verbeter_je_zelfbeeld_-_Eenvoudige_taal',
    'Werkgeluk',
    'Werkhervattingsplan',
    'Worrying',
    'Zelfbeeld',
    'Zelfbeeld-kinderen',
    'Zelfbeeld-ouders',
    'Zelfcompassie',
];

export function GgzbTherV1IndexListModal(props: IGgzbTherV1IndexListModalProps) {
    return (
        <Modal
            actionButtons={[
                <Button onClick={async () => await props.setShowModal(!props.showModal)}>
                    {' '}
                    {translateKey('common.close')}
                </Button>,
            ]}
            isOpen={props.showModal}
            onClose={async () => await props.setShowModal(!props.showModal)}
            size="large"
            title="Inhoudsopgaven van programma's"
        >
            <Text>
                Wil je meer weten over de inhoud van een programma van Therapieland? Bekijk dan per programma de hele
                inhoudsopgave.
            </Text>
            <div style={{ columns: '20rem 3' }}>
                <List>
                    {filenames.map((filename) => (
                        <ListItem key={filename}>
                            <AnchorLink
                                openInNewTab
                                to={getUrl(filename)}
                            >
                                {removeUnderscores(filename)}
                            </AnchorLink>
                        </ListItem>
                    ))}
                </List>
            </div>
        </Modal>
    );
}

function removeUnderscores(filename: string) {
    return filename.replace(/\_/g, ' ');
}

function getUrl(filename: string) {
    return `assets/documents/therapieland/${filename}.pdf`;
}
